// 로그인 오류 신고 API mock (로컬 개발용, VUE_APP_ERROR_REPORT_MOCK=true 일 때만 사용)
// 전송 실패 테스트: sessionStorage.setItem('mockErrorReportFail', '1')
// 서버 거절 테스트: sessionStorage.setItem('mockErrorReportReason', 'too_many_requests')

const SCHOOL_NAMES = [
  '알공초등학교',
  '한빛초등학교',
  '새솔초등학교',
  '푸른초등학교',
  '중앙초등학교',
  '동부초등학교',
  '서부초등학교',
  '햇살초등학교'
]

function delay(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

async function mockSearchSchools(keyword) {
  await delay(200)
  const word = keyword.trim()
  return SCHOOL_NAMES.map((schoolName, i) => ({
    id: `mock-${i}`,
    name: `서울 ${schoolName}`,
    schoolName,
    location: '서울'
  })).filter((school) =>
    word.split(/\s+/).every((w) => school.name.includes(w))
  )
}

async function mockSubmitErrorReport(payload) {
  await delay(800)
  console.info('[mock] 로그인 오류 신고 payload', payload)
  if (sessionStorage.getItem('mockErrorReportFail') === '1') {
    throw new Error('mock submit failed')
  }
  const reason = sessionStorage.getItem('mockErrorReportReason')
  if (reason) return { success: false, reason }
  return { success: true, reason: '' }
}

export { mockSearchSchools, mockSubmitErrorReport }
